<!-- ================================================================ -->
<!--                Form Warnings          -->
<!-- ================================================================ -->
<div *ngIf="parking.numberOfBays <= 0 && selectedPlan?.feeInCents">
    <h4 class="numberOfBays-heading p-3">0 parking spots available</h4>
</div>
<div *ngIf="!selectedPlan?.feeInCents">
    <h4 class="numberOfBays-heading p-3">More details coming soon</h4>
</div>

<ng-container *ngIf="user && profile">
    <!-- ================================================================ -->
    <!--                Form           -->
    <!-- ================================================================ -->
    <form (ngSubmit)="createSubscription()" *ngIf="parking.numberOfBays > 0 && selectedPlan?.feeInCents" [formGroup]="formData" autocomplete="off" novalidate>
        <div class="container-fluid px-0">
            <div class="row mt-2">
                <div class="form-group col-6" id="bays-form-group">
                    <label class="required" for="input-parkingBays">Number of bays</label>
                    <input class="form-control" formControlName="baysBooked" id="input-parkingBays" min="1" name="baysBooked" type="number" />
                </div>

                <div class="form-group col-6">
                    <label class="required" for="input-contractLength">Duration</label>
                    <div class="input-group">
                        <input class="form-control" formControlName="contractLength" id="input-contractLength" max="12" min="1" name="contractLength" type="number" />
                        <div class="input-group-text">
                            <span *ngIf="selectedPlan?.term == 'MONTHLY'">Months</span>
                            <span *ngIf="selectedPlan?.term == 'DAILY'">Days</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="form-group col-6">
                    <label class="required" for="input-dateFrom">Start Date</label>
                    <input class="form-control" formControlName="startDate" id="input-dateFrom" name="startDate" type="date" />
                </div>

                <div class="form-group col-6">
                    <label for="input-parkingBays">End Date</label><span class="muted small"> (automatic)</span>
                    <input class="form-control" formControlName="endDate" id="input-endDate" name="endDate" type="text" readonly />
                </div>
            </div>

            <div class="row mt-3">
                <ng-container *ngIf="parking && parking.usePolicyUrl">
                    <div class="row">
                        <div class="col-12 mb-1 ms-1">
                            <div class="form-check d-flex align-items-center">
                                <input (change)="toggleLandlordUsePolicyAccepted()" CHECKED class="form-check-input" id="ownerTerms" type="checkbox" value="" />
                                <label class="terms-label mb-0 ms-2" for="ownerTerms">
                                    I agree to the Landlord's
                                    <a class="link-info text-decoration-underline" href="{{ parking.usePolicyUrl }}" target="_blank">Parking Use Policy and Terms</a>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="parking && parking.leaseAgreementUrl">
                    <div class="row">
                        <div class="col-12 mb-1 ms-1">
                            <div class="form-check">
                                <input (change)="toggleLandlordLeaseAgreementAccepted()" CHECKED class="form-check-input mt-2" id="leaseAgreement" type="checkbox" value="" />
                                <label class="terms-label" for="leaseAgreement">
                                    I understand that I will need to sign a
                                    <a class="link-info text-decoration-underline" href="{{ parking.leaseAgreementUrl }}" target="_blank">Lease Agreement</a>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="parking">
                    <div class="row">
                        <div class="col-12 mb-1 ms-1">
                            <div class="form-check">
                                <input (change)="toggleParkUppTermsAccepted()" CHECKED class="form-check-input mt-2" id="terms" type="checkbox" value="" />
                                <label class="terms-label" for="terms">
                                    I agree to ParkUpp's
                                    <a [routerLink]="['/terms-and-conditions']" class="link-info text-decoration-underline" target="_blank"> Terms and Conditions</a> as the marketplace
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="row mt-3">
                <div *ngIf="formError" class="form-group col-12 mt-3 alert alert-danger" role="alert">
                    {{ formError }}
                </div>

                <div class="form-group col-12 mt-1">
                    <button
                        [disabled]="!formData.valid || formLoading || !landlordUsePolicyAccepted || !landlordLeaseAgreementAccepted || !parkUppTermsAccepted"
                        [ngClass]="EnumNames.getSubscriptionTypeClass(inputSubscriptionType)"
                        class="text-white btn w-100"
                        type="submit"
                    >
                        <span *ngIf="formLoading" aria-hidden="true" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                        <div class="btn-line-1 text-white">Create Parking Request</div>
                        <div class="btn-line-2 text-white">{{ getButtonText() }}</div>
                    </button>
                </div>

                <div class="col-12 mt-2 text-center">
                    <div class="small text-muted">The parking manager should confirm within 24 hours. This might be affected by weekends or public holidays.</div>
                </div>
            </div>
        </div>
    </form>
</ng-container>
<ng-container *ngIf="!user">
    <div class="mt-3 text-center">
        <a (click)="globalService.redirectToRegister()" class="mt-2 text-white btn bg-blue w-100">
            <div class="btn-line-1 text-white">Create a ParkUpp Profile</div>
            <div class="btn-line-2 text-white">It's completely FREE and takes less than 2 minutes</div>
        </a>
    </div>
</ng-container>
